import React, { Component } from 'react';
import { animated } from '@react-spring/web';
import { arrayOf, element, oneOfType, string } from 'prop-types';
import { classNames, isFunction } from '@philips-internal/oswald-ui-utils';
import './backdrop.css';
class Backdrop extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { onClick } = this.props;
            isFunction(onClick) && onClick();
        };
    }
    getClassNames() {
        const { className } = this.props;
        return classNames({
            'c-backdrop': true,
            [`${className}`]: Boolean(className),
        });
    }
    render() {
        const { children, style } = this.props;
        return (React.createElement(animated.div, { className: this.getClassNames(), onClick: this.handleClick, role: "region", style: style }, children));
    }
}
Backdrop.propTypes = {
    children: oneOfType([element, arrayOf(element)]),
    className: string,
};
export { Backdrop, };
export default Backdrop;
//# sourceMappingURL=backdrop.js.map